// @flow
import type { Props } from './types';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import generalIcons from '~/core/constants/icons/general-svg';
import IconsSummary from '../../../icons-summary/component';
import messages from '../intl';
import { ActionContainer, ActionIcons, Name, RemoveActionButton, RemoveActionContainer, Status } from './styles';

// $FlowFixMe
const ActionComponent = ({ action, actionBeingDeleted, chooseAction, icons, removeAction }: Props) => (
    <ActionContainer active={!actionBeingDeleted} onClick={!actionBeingDeleted ? chooseAction : null}>
        <ActionIcons>
            {icons && (
                <IconsSummary _while={icons.while} disabled={!action.enabled} then={icons.then} when={icons.when} />
            )}
        </ActionIcons>
        <RemoveActionContainer
            onClick={
                actionBeingDeleted
                    ? null
                    : (e: MouseEvent) => {
                          e.stopPropagation();
                          removeAction();
                      }
            }
        >
            <RemoveActionButton type={generalIcons.TRASH} />
        </RemoveActionContainer>
        <Name>
            <span>{action.name}</span>
        </Name>
        <Status enabled={action.enabled}>
            {action.enabled ? (
                <FormattedMessage {...messages.enabledAction} />
            ) : (
                <FormattedMessage {...messages.disabledAction} />
            )}
        </Status>
    </ActionContainer>
);

export default ActionComponent;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/my-actions/action/component.js